import { render } from "./MatchKinds.vue?vue&type=template&id=b99f5888"
import script from "./MatchKinds.vue?vue&type=script&lang=js"
export * from "./MatchKinds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__